import Cookies from 'js-cookie';

document.addEventListener("DOMContentLoaded", async function() {

    //fetch all nearest branch fields
    let nearest_branch_fields = document.querySelectorAll('select[name="nearest_branch"]');

    //if we have some fields to process
    if(nearest_branch_fields && nearest_branch_fields.length > 0) {

        //if we have a preferred branch
        if(Cookies.get('bt_preferred_branch')) {

            //get our preferred branch
            let preferred_branch = Cookies.get('bt_preferred_branch');

            //loop through all the nearest branch fields
            nearest_branch_fields.forEach(function(field) {

                //if this field contains our preferred branch
                if(field.querySelector('option[value="' + preferred_branch + '"]')) {

                    //select the preferred branch
                    field.value = preferred_branch;

                    //trigger the change event
                    field.dispatchEvent(new Event('change'));

                    return;
                }
            });
        } else { //otherwise...

            let postcode = false;

            //if we have access to a saved search
            if(Cookies.get('bt_search')) {

                //attempt to parse our search
                let search = JSON.parse(Cookies.get('bt_search'));

                //if we have a postcode
                if(search && search.postcode) {

                    //save our postcode
                    postcode = search.postcode;
                }
            }

            //if after parsing our search we still don't have a postcode
            if(!postcode) {

                //fetch the params from the URL
                let params = new URLSearchParams(window.location.search);

                //if we have a postcode in the URL and it's not blank
                if(params.get('postcode') && params.get('postcode') != '') {

                    //save our postcode
                    postcode = params.get('postcode');
                }
            }

            //if we have a postcode to work with...
            if(postcode) {

                //fetch the lat and lng coordinates for the postcode
                let nearest_branches = await get_closest_branches(postcode);

                //loop through all the nearest branch fields
                nearest_branch_fields.forEach(function(field) {

                    //this will hold all the valid options for the select field
                    let valid_options = [];

                    //loop through all the options in the select field
                    field.querySelectorAll('option').forEach(function(option) {

                        //if the option is the default option...
                        if(option.value == '') {

                            //bail
                            return;
                        }

                        //sets a default position
                        let position = 0;

                        //loop through all the nearest branches
                        nearest_branches.forEach(function(branch) {

                            //if the branch name matches the option value
                            if(branch.data.name === option.value) {

                                //change the option text to include the distance
                                option.innerHTML = branch.data.name + ' - (' + branch.distance + ' mile' + (branch.distance > 1 ? 's' : '') + ' away)';

                                //add the branch at this position to the valid options array
                                valid_options[position] = option;
                            }

                            //increment the position
                            position++;
                        });
                    });

                    //if we have some valid options...
                    if(valid_options.length > 0) {

                        //clear existing options
                        while (field.firstChild) {
                            field.removeChild(field.firstChild);
                        }

                        //add new options
                        valid_options.forEach((option, index) => {

                            //add this field
                            field.add(option);
                        });

                        //select the first option
                        field.selectedIndex = 0;

                        //trigger the change event
                        field.dispatchEvent(new Event('change'));
                    }
                });
            }
        }
    }

    function get_closest_branches(postcode) {

        //return a promise
        return new Promise((resolve, reject) => {

            //create a new AJAX request
            var xhttp = new XMLHttpRequest();

            //when the request is complete
            xhttp.onreadystatechange = function() {

                //if the request was successful
                if (this.readyState === 4) {

                    //if the request was successful
                    if (this.status === 200) {

                        //if we have no response text or it's blank
                        if(!this.responseText || this.responseText == '') {

                            //reject the promise
                            reject('No response text');
                            return;
                        }

                        //resolve the promise with the parsed JSON response
                        resolve(JSON.parse(this.responseText));
                    } else { //if the request failed

                        //reject the promise
                        reject('Request failed with status ' + this.status);
                    }
                }
            };

            //open the request
            xhttp.open("GET", '/wp-json/laserred/branches?origin=' + postcode + '&proximity=50', true);

            //send the request
            xhttp.send();
        });
    }
});